"use strict";

exports.__esModule = true;
exports.default = void 0;
var _helpers = require("../../helpers");
class Actions extends _helpers.ActionHelper {
  constructor() {
    super({
      singular: 'permission'
    });
  }
}
const actions = new Actions();
var _default = exports.default = actions;
module.exports = exports.default;